import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BUSINESS } from '@core/constants';
import { CustomerPortalPayload, CustomerPortalQuote } from '@core/models';

@Component({
  selector: 'app-quote-document',
  imports: [CommonModule],
  templateUrl: './quote-document.component.html',
  styleUrl: './quote-document.component.scss',
})
export class QuoteDocumentComponent {
  @Input({ required: true }) data!: CustomerPortalPayload;

  readonly businessName = BUSINESS.name;
  readonly businessNit = BUSINESS.nit;

  get quotes(): CustomerPortalQuote[] {
    return [...(this.data.quotes ?? [])].sort((a, b) => b.version - a.version);
  }

  quoteStatusLabel(status: string | null): string {
    if (status === 'APPROVED') return 'Aprobada';
    if (status === 'PARTIAL') return 'Parcial';
    if (status === 'REJECTED') return 'Rechazada';
    if (status === 'SENT') return 'Enviada';
    return 'Pendiente';
  }

  quotedTotal(quote: CustomerPortalQuote): number {
    if (typeof quote.total === 'number' && quote.total > 0) {
      return quote.total;
    }
    return quote.items.reduce((sum, item) => sum + (item.price ?? 0), 0);
  }

  approvedItems(quote: CustomerPortalQuote) {
    return quote.items.filter((item) => item.approved === true);
  }

  approvedCount(quote: CustomerPortalQuote): number {
    return this.approvedItems(quote).length;
  }

  rejectedCount(quote: CustomerPortalQuote): number {
    return quote.items.filter((item) => item.approved === false).length;
  }

  pendingCount(quote: CustomerPortalQuote): number {
    return quote.items.filter((item) => item.approved === null).length;
  }
}
